// お問い合わせステップの型
export type ContactStep = 'form' | 'confirm' | 'complete';

// お問い合わせフォームデータの型
export interface ContactFormData {
  category: string;      // お問い合わせ種別
  name: string;          // 氏名
  email: string;         // メールアドレス
  tel?: string;          // 電話番号
  company?: string;      // 会社名/団体名
  content: string;       // お問い合わせ内容
  attachment?: File;     // 添付ファイル
  agree: boolean;        // 個人情報の取り扱いへの同意
}

// お問い合わせ種別の選択肢
export const CONTACT_CATEGORIES = [
  'どんなことを頼めるのか相談したい',
  '見積もりについて相談したい',
  'スペシャリストとして関わり方を知りたい',
  'SOREMO OSについて知りたい',
  'その他のお問い合わせ',
] as const;

export type ContactCategory = typeof CONTACT_CATEGORIES[number];
